import { AgColumnDefinition, AgGridColumnType, AgGridExportType } from '@/shared/models/ag-grid.model'
import i18n from '@/lang/i18n'

export const billingModalInvoicesAddToGridColumnDefs =
    (): Array<AgColumnDefinition> => [
        {
            type: AgGridColumnType.CUSTOM_CHECKBOX,
            headerComponent: undefined
        },
        {
            headerName: i18n.tc('accounting.field.invoice'),
            field: 'label',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.client'),
            field: 'customer.name',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.generationDate'),
            field: 'generationDate',
            type: AgGridColumnType.DATETIME,
            exportType: AgGridExportType.DATETIME,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.generationResponsible'),
            colId: 'generator.normalizedFullName',
            field: 'generator.fullName',
            type: AgGridColumnType.TEXT,
            exportType: AgGridExportType.TEXT,
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            headerName: i18n.tc('accounting.field.deliveryNote', 2),
            field: 'billableDeliveryNoteCount',
            type: AgGridColumnType.NUMBER,
            exportType: AgGridExportType.NUMBER,
            minWidth: 100,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: false
        },
        {
            headerName: i18n.tc('accounting.field.total'),
            field: 'conceptsTotalValue',
            type: AgGridColumnType.DECIMAL,
            exportType: AgGridExportType.DOUBLE,
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        }
    ]
